import { CustomerQuestionnaireEdit } from '../translations-types';

const translations: CustomerQuestionnaireEdit = {
  editQuestionnaireSubmission: 'Wijzig vragenlijst antwoorden',
};

export default translations;
